angular.module('bmsApp.trugreen.quote', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.trugreen.quote', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/trugreen/quote/templates/QuoteMain.html',
							controller: 'TGQuoteMainCtrl'
						}
					}
				})

				.state('main.trugreen.quote.index', {
					url: '^/trugreen/quotes',
					views: {
						'content@main.trugreen.quote': {
							templateUrl: 'ng/trugreen/quote/templates/QuoteIndex.html',
							controller: 'TGQuoteIndexCtrl'
						},
						'side@main.trugreen.quote': {
							templateUrl: "ng/trugreen/quote/templates/QuoteIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Quotes'}
				})

				.state('main.trugreen.quote.index.createProforma', {
					url: '^/trugreen/proforma-quote/add/{enquiryId}',
					views: {
						'content@main.trugreen.quote': {
							templateUrl: 'ng/trugreen/quote/templates/QuoteSave.html',
							controller: 'TGQuoteSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Add Proforma Quote'}
				})

				.state('main.trugreen.quote.index.create', {
					url: '^/trugreen/quote/add/{customerId}',
					views: {
						'content@main.trugreen.quote': {
							templateUrl: 'ng/trugreen/quote/templates/QuoteSave.html',
							controller: 'TGQuoteSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Add Quote'}
				})

				.state('main.trugreen.quote.index.view.update', {
					url: '^/trugreen/quote/edit/{quoteId:int}',
					views: {
						'content@main.trugreen.quote': {
							templateUrl: 'ng/trugreen/quote/templates/QuoteSave.html',
							controller: 'TGQuoteSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Edit Quote'}
				})

				.state('main.trugreen.quote.index.view', {
					url: '^/trugreen/quote/view/{quoteId:int}',
					views: {
						'content@main.trugreen.quote': {
							templateUrl: 'ng/trugreen/quote/templates/QuoteView.html',
							controller: 'TGQuoteViewCtrl'
						}
					},
					ncyBreadcrumb: { label: "{{ quote.name }}" }
				})

				.state('main.trugreen.quote.index.view.updateProforma', {
					url: '^/trugreen/proforma-quote/edit/{quoteId:int}',
					views: {
						'content@main.trugreen.quote': {
							templateUrl: 'ng/trugreen/quote/templates/QuoteSave.html',
							controller: 'TGQuoteSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Edit Proforma Quote'}
				})

				.state('main.trugreen.quote.index.view.convert', {
					url: '^/trugreen/quote/convert/{quoteId}',
					views: {
						'content@main.trugreen.quote': {
							templateUrl: 'ng/trugreen/job/templates/JobSave.html',
							controller: 'TGJobSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Convert Quote'}
				})

			;

		}]);
